'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    colorPickerClassNames: function() {
        return colorPickerClassNames;
    },
    useColorPickerStyles_unstable: function() {
        return useColorPickerStyles_unstable;
    }
});
const _react = require("@griffel/react");
const colorPickerClassNames = {
    root: 'fui-ColorPicker'
};
/**
 * Styles for the root slot
 */ const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        mc9l5x: "f22iagw",
        Beiy3e4: "f1vx9l62",
        i8kkvl: 0,
        Belr9w4: 0,
        rmohyg: "f7e3wsx"
    }
}, {
    d: [
        ".f22iagw{display:flex;}",
        ".f1vx9l62{flex-direction:column;}",
        [
            ".f7e3wsx{gap:var(--spacingVerticalXS);}",
            {
                p: -1
            }
        ]
    ]
});
const useColorPickerStyles_unstable = (state)=>{
    'use no memo';
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(colorPickerClassNames.root, styles.root, state.root.className);
    return state;
};
